const uri = '/apps/vehicle-request-api/api/v1/VehicleRequest/AddVehicleRequest';

function addItem() {
    const addYearTextbox = document.getElementById('Year');
    const addMakeTextbox = document.getElementById('Make');
    const addModelTextbox = document.getElementById('Model');
    const addSubmodelTextbox = document.getElementById('Submodel');
    const addEngineLiterTextbox = document.getElementById('EngineLiter');
   
    const addModsTextbox = document.getElementById('Mods');
    const addModsDescriptionTextbox = document.getElementById('ModsDescription');
    const addNameTextbox = document.getElementById('Name');
    const addEmailTextbox = document.getElementById('Email');
    const addPhoneTextbox = document.getElementById('Phone');
    const addStateTextbox = document.getElementById('State');

    //this is a quick bot filter
    const honeyPotBotFilter = document.getElementById('Company');

    if (honeyPotBotFilter.value !== "") {
        return; // bot detected
    }

    let isMod

    if (addModsTextbox.value.trim() == 'true')
        isMod = true
    else
        isMod = false

        //Not in Use
        const oldItem = {
            sender: 'VehicleRequestForm',
            action: 'add',
            data:{
            year: parseInt(addYearTextbox.value.trim()),
            make: addMakeTextbox.value.trim(),
            model: addModelTextbox.value.trim(),
            submodel: addSubmodelTextbox.value.trim(),
            engineLiter: addEngineLiterTextbox.value.trim(),
            isModified: isMod,
            modsDescription: addModsDescriptionTextbox.value.trim(),
            name: addNameTextbox.value.trim(),
            email: addEmailTextbox.value.trim(),
            phoneNumber: addPhoneTextbox.value.trim(),
            state: addStateTextbox.value.trim(),
            }
        };

        const item = {
            year: parseInt(addYearTextbox.value.trim()),
            make: addMakeTextbox.value.trim(),
            model: addModelTextbox.value.trim(),
            submodel: addSubmodelTextbox.value.trim(),
            engineLiter: addEngineLiterTextbox.value.trim(),
            isModified: isMod,
            modsDescription: addModsDescriptionTextbox.value.trim(),
            name: addNameTextbox.value.trim(),
            email: addEmailTextbox.value.trim(),
            phoneNumber: addPhoneTextbox.value.trim(),
            state: addStateTextbox.value.trim()
        };

    fetch(uri, {
        method: 'post',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(item)
    }).then(function(response) {
        if (response.ok === true) {
            window.location.href = '../pages/new-vehicle-request-confirmation';
        } else {
            alert('Form not submitted, please try again.');
        }
    });
}